import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import HttpBackend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import { backendUrl, apiVersion, customerName } from "./constants/constants";

const getLanguageFromUrl = () => {
  const path = window.location.pathname;
  const segments = path.split("/");

  const languageSegment = segments.find((segment) =>
    /^[a-z]{2}_[A-Z]{2}$/.test(segment)
  );

  // If the language segment is not found in the URL, return the language already set from local storage as a fallback use "en_US"
  return languageSegment || localStorage.getItem('i18nextLng') || "en_US";
};

const language = getLanguageFromUrl();
i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng: language,
    fallbackLng: "en_US",
    backend: {
      loadPath: `${backendUrl}/${apiVersion}/translations`,
      customHeaders: {
        "Content-Type": "application/json",
        customerName: customerName || window.location.host.split(".")[0],
        language: language, // Dynamically set the language
      },
    },
    detection: {
      order: ["path", "querystring", "localStorage", "navigator"],
      caches: ["localStorage"],
    },
    lowerCaseLng: true,
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
